import { IGetEndOfLife } from './types'

// The enum filters the grid's search widens into, copied from material-emission-grid/helpers.ts.
// productTaxonomyLevel is deliberately absent: it is a two-value record attribute, not something
// the free-text search should match on.
export const getEndOfLifeVars: IGetEndOfLife = {
  secondaryDataReferenceSourceType: {
    in: [
      'PrimaryDataFromIndustrySenseChecked',
      'PrimaryDataMeasurementsTakenByMondra',
      'PeerReviewedPublishedLiterature',
      'PublishedBook',
      'IndustryPublishedReport',
      'Ecoinvent',
      'AgriFootPrint',
      'GovernmentFundedOrganizationReport',
      'NonGovernmentalFundedOrganizationReport',
      'Patent',
      'CompanyWebsite',
      'BlogWebsiteForum',
      'OpenSourceWebsite',
      'UndocumentedEstimate',
    ],
  },
  state: {
    in: ['Unpublished', 'Published'],
  },
}
